module.exports = __webpack_public_path__ + "img/office-desk-dark.fd5d0b7a.svg";